import { z } from 'zod'

import { PostTimelineSchema } from './Time'

export const PostSchema = z.object({
  postId: z.string(),
  createdAt: z.string(),
  displayName: z.string(),
  username: z.string(),
  profilePicture: z.string().nullable(),
  postText: z.string().nullable(),
  postMedia: z.string().nullable(),
  mediaTypes: z.string().nullable(),
  likeCount: z.number(),
  replyCount: z.number(),
  timeline: PostTimelineSchema,
})

export const ReplySchema = PostSchema.pick({
  postId: true,
  createdAt: true,
  postText: true,
  likeCount: true,
  replyCount: true,
}).extend({
  replyId: z.string(),
  replierUserName: PostSchema.shape.username,
  replierDisplayName: PostSchema.shape.displayName,
  replierProfilePicture: PostSchema.shape.profilePicture,
  posterUserName: PostSchema.shape.username,
  timeline: PostTimelineSchema,
})

export const ResponsePostsSchema = z.object({
  posts: z.array(PostSchema),
  nextPage: z.boolean(),
})

export const ResponseRepliesSchema = z.object({
  replies: z.array(ReplySchema),
  nextPage: z.boolean(),
  nextPageCount: z.number(),
})

export type Post = z.infer<typeof PostSchema>
export type Reply = z.infer<typeof ReplySchema>
export type ResponsePosts = z.infer<typeof ResponsePostsSchema>
export type ResponseReplies = z.infer<typeof ResponseRepliesSchema>

export const isPost = (post: any): post is Post => {
  return PostSchema.safeParse(post).success
}

export const isReply = (reply: any): reply is Reply => {
  return ReplySchema.safeParse(reply).success
}

export const isResponsePosts = (res: any): res is ResponsePosts => {
  return ResponsePostsSchema.safeParse(res).success
}

export const isResponseReplies = (res: any): res is ResponseReplies => {
  return ResponseRepliesSchema.safeParse(res).success
}
